/**
 * Per-workflow flow snapshot comparison section.
 *
 * @module config-comparison/WorkflowDiffSection
 */
import React from 'react';
import { Text } from '@chatsdet/ui';
import type { EnvironmentSnapshot } from '@chatsdet/types';
import { DiffTable } from './DiffTable';
import { diffRecordMap } from './diff-utils';

type WorkflowSnapshotMap = EnvironmentSnapshot['workflows'];

interface WorkflowDiffSectionProps {
  workflowsA: WorkflowSnapshotMap | undefined;
  workflowsB: WorkflowSnapshotMap | undefined;
  labelA: string;
  labelB: string;
}

export function WorkflowDiffSection({ workflowsA, workflowsB, labelA, labelB }: WorkflowDiffSectionProps) {
  const rows = React.useMemo(
    () => diffRecordMap(workflowsA, workflowsB, {
      format: (wf) => `v${wf.snapshotVersion} (${wf.nodeCount}n/${wf.edgeCount}e) ${wf.snapshotHash.slice(0, 8)}`,
      isEqual: (a, b) => a.snapshotHash === b.snapshotHash && a.snapshotVersion === b.snapshotVersion,
      keyLabel: (_id, wf) => wf?.name ?? _id.slice(0, 8),
    }),
    [workflowsA, workflowsB],
  );

  return (
    <div>
      <Text weight="medium" className="mb-2">Workflow Flows</Text>
      <DiffTable rows={rows} labelA={labelA} labelB={labelB} />
    </div>
  );
}
